import { useState, useEffect, useCallback } from 'react';
import { TrendingUp, RefreshCw, Clock } from 'lucide-react';
import { adminApi } from '@/utils/api';

export const FinancialAudit = () => {
    const [transactions, setTransactions] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchAudit = useCallback(async () => {
        try {
            const res = await adminApi.getFinancialAudit();
            const data = await res.json();
            if (data.success) setTransactions(data.transactions);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, []);

    useEffect(() => {
        fetchAudit();
        const interval = setInterval(fetchAudit, 15000);
        return () => clearInterval(interval);
    }, [fetchAudit]);

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-green-400/60 flex items-center gap-2">
                    <TrendingUp size={10} /> Real-Time Financial Feed
                </h3>
                <button onClick={fetchAudit} className="p-1.5 hover:bg-white/5 rounded-lg text-white/20 hover:text-white transition-all">
                    <RefreshCw size={12} className={loading ? "animate-spin" : ""} />
                </button>
            </div>
            {loading ? <div className="p-4 bg-white/5 rounded-xl animate-pulse h-40" /> : (
                <div className="bg-black/40 rounded-2xl border border-white/5 overflow-hidden">
                    <div className="max-h-[400px] overflow-y-auto divide-y divide-white/5 custom-scrollbar">
                        {transactions.map(tx => (
                            <div key={tx.transaction_id} className="p-3 flex items-center justify-between hover:bg-white/5 transition-colors">
                                <div className="flex items-center gap-3">
                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-black border ${tx.amount < 0 ? 'bg-red-500/10 text-red-400 border-red-500/20' : 'bg-green-500/10 text-green-400 border-green-500/20'}`}>
                                        {tx.transaction_type === 'fee' ? '%' : (tx.amount < 0 ? '-' : '+')}
                                    </div>
                                    <div className="space-y-0.5">
                                        <div className="text-[11px] font-bold text-white flex items-center gap-1.5">
                                            {tx.transaction_type.toUpperCase()}
                                            <span className="text-[10px] text-white/30">• @{tx.username || 'sys'}</span>
                                        </div>
                                        <div className="text-[9px] text-white/40 max-w-[150px] truncate">{tx.description}</div>
                                    </div>
                                </div>
                                <div className="text-right space-y-0.5">
                                    <div className={`text-xs font-black font-mono ${tx.amount < 0 ? 'text-red-400' : 'text-green-400'}`}>
                                        {Number(tx.amount).toFixed(2)}
                                    </div>
                                    <div className="text-[9px] text-white/20 flex items-center gap-1 justify-end">
                                        <Clock size={8} /> {new Date(tx.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
